// Ogłoszenie z ostatnich 48 godzin; `now` liczone raz na listę.
const FRESH_WINDOW_MS = 48 * 60 * 60 * 1000

export function isOfferFresh(offer, now) {
	const created = offer?.created
	if (!created) return false
	const createdMs = new Date(created).getTime()
	if (Number.isNaN(createdMs)) return false
	return now - createdMs < FRESH_WINDOW_MS
}
